import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';
import { version } from '@env/version';

export const CLIENT_VERSION_HEADER = 'X-Client-Version';

/**
 * Manda la versión del front (la de package.json) en cada request a la API, para que el back sepa
 * con qué versión del front vino cada request. Sólo a la API propia: a Cloudinary, Google o Mercado Pago un
 * header que no conocen les puede hacer fallar el preflight de CORS.
 */
export const clientVersionInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.backendUrl)) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { [CLIENT_VERSION_HEADER]: version.version } }));
};
